import { useTranslation } from 'react-i18next';

import {
  SAMPLE_APPROVAL_STATUS_OPTIONS,
  SAMPLE_APPROVAL_STATUS_DEFAULT,
  getSampleApprovalSwatchClass,
} from '../../constants/sample-approval-status.constants';
import './SampleApprovalStatusTag.scss';

export interface SampleApprovalStatusTagProps {
  /** Prefix label, e.g. "Licensing" / "Customer" (already translated). Omit/empty to hide it — e.g. when the column header already names the status. */
  label?: string;
  /** Stored approval-status value. */
  value?: string | null;
  'data-testid'?: string;
}

/**
 * Read-only licensing/customer approval-status pill for list tables (BM-9882).
 * Displays a swatch-coloured tag with the translated status, prefixed by the
 * column label. Reuses the shared options so it can never show a value the
 * editable pill cannot set.
 */
function SampleApprovalStatusTag({ label, value, 'data-testid': dataTestId }: SampleApprovalStatusTagProps) {
  const { t } = useTranslation('product-sample');
  const resolved = value ?? SAMPLE_APPROVAL_STATUS_DEFAULT;
  const option = SAMPLE_APPROVAL_STATUS_OPTIONS.find((item) => item.value === resolved);
  const swatch = getSampleApprovalSwatchClass(resolved);

  return (
    <div className={`sample-approval-tag sample-approval-tag--${swatch}`} data-testid={dataTestId}>
      {label ? <span className="sample-approval-tag__label">{label}</span> : null}
      <span className="sample-approval-tag__value">{option ? t(option.labelKey) : resolved}</span>
    </div>
  );
}

export default SampleApprovalStatusTag;
